/**
  A Lorinthe project.

  @Author: Tom Voorneveld <tom>
  @Date:   2019-06-12T16:35:39+02:00
  @Email:  tom@lorinthe.com
  @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-06-12T17:47:45+02:00
  @Copyright: (c) copyright Lorinthe BV, all rights reserved

  Mixin add this method to ALL components.
  Use for example:

  <img :src="assetUrl('img/prices/consult.jpg')">

*/

const IMAGES = require.context('@/assets/', true, /\.(?:jpg|gif|png|svg|webm|mp4|vtt|pdf|)$/)

const ASSET_URL_METHOD = {
  methods: {
    assetUrl (url) {
      return IMAGES('./' + url)
    }
  }
}

export default ASSET_URL_METHOD
